import './sass/main.scss';

require("./vendors/fancybox/jquery.fancybox.min");
require("./vendors/match-height/jquery.matchHeight");
require("./vendors/slick/slick.min");
require("./vendors/counter/jquery.counter.min");
require("./vendors/counter/jquery.waypoints.min");
require("bootstrap/dist/js/bootstrap.bundle.min");
require("./vendors/pollyfill/pollyfill.min");
require('mutationobserver-polyfill');

global.domtoimage = require("./vendors/dom-to-image");

require("./js/common");

import ss from "./js/scripts";
import extractTemplateContent from "./js/template";
import lozad from 'lozad';

function initLozad() {
    lozad([
        ".lazyload",
        '.bg-cover',
        "img[data-src]:not([src])",
        "iframe[data-src]:not([src])"
    ].join(','), {
        loaded: function (element) {
            if (element.classList.contains('lazyload')) {
                element.classList.remove('lazyload');
                element.classList.add('lazyloaded');

                let template = element.querySelector("template");
                if (template) {
                    extractTemplateContent(template);
                }

                element.dispatchEvent(new CustomEvent('lazyloaded', {
                    detail: {},
                    bubbles: true,
                    cancelable: true
                }));
            }

            if (element.classList.contains('bg-cover')) {
                let img = element.querySelector(":scope > img");
                if (img) {
                    if (!img.src) {
                        img.onload = function () {
                            element.style.backgroundImage = `url('${img.currentSrc ? img.currentSrc : img.src}')`;
                        };
                        img.removeAttribute('loading');
                        img.src = img.getAttribute('data-src');
                    } else {
                        element.style.backgroundImage = `url('${img.currentSrc ? img.currentSrc : img.src}')`;
                    }
                }
            }

            if (element.dataset.src && !element.src) {
                element.src = element.getAttribute('data-src');
                element.removeAttribute('data-src');
            }
        }
    }).observe();
}

initLozad();
var observer = new MutationObserver(function (mutationsList, observer) {
    if (mutationsList.find(function (item) {
        return item.type == "childList" && item.addedNodes.length > 0 && item.target.nodeType == 1 && Array.prototype.find.call(item.addedNodes, function (child) {
            return child.nodeType == 1;
        });
    })) {
        initLozad();
    }
});
observer.observe(document.body, {attributes: false, childList: true, subtree: true});

ss.init();
document.addEventListener('lazyContentLoaded', function (e) {
    ss.slider(e.target);
    ss.misc(e.target);
});

document.querySelectorAll(".js-video-poster-image[data-video-id]").forEach(function (img) {
    img.addEventListener("load", function (e) {
        document.getElementById(e.target.getAttribute("data-video-id")).setAttribute("poster", (e.target.currentSrc ? e.target.currentSrc : e.target.src));
    });
});

document.querySelectorAll("template.js-conditional-extraction").forEach(function (template) {
    if (window.innerWidth >= template.getAttribute("data-min-width")) {
        extractTemplateContent(template);
    }
});